import { setupIdentityConfig } from './identity-config';

setupIdentityConfig({
    authority: global?.IdentityServerConfig?.authority,
    scope: global?.IdentityServerConfig?.scope,
    grant_type: global?.IdentityServerConfig?.grant_type,
    client_id: global?.IdentityServerConfig?.client_id,
    tenant_uid: global?.IdentityServerConfig?.tenant_uid,
    tuid: global?.IdentityServerConfig?.tenant_uid,
    response_type: global?.IdentityServerConfig?.response_type,
    acr_values: global?.IdentityServerConfig?.acr_values,
    redirect_uri: global?.IdentityServerConfig?.redirect_uri,
    post_logout_redirect_uri: global?.IdentityServerConfig?.post_logout_redirect_uri,
    silent_redirect_uri: global?.IdentityServerConfig?.silent_redirect_uri,
    response_mode: global?.IdentityServerConfig?.response_mode,
    automaticSilentRenew: global?.IdentityServerConfig?.automaticSilentRenew,
    accessTokenExpiringNotificationTime: global?.IdentityServerConfig?.accessTokenExpiringNotificationTime,
    silentRequestTimeout: global?.IdentityServerConfig?.silentRequestTimeout,
});
